export const ACCEPTED_UPLOAD_FILE_TYPES =
    'image/png,image/jpeg,image/jpg,image/webp,image/gif,image/svg+xml,image/bmp,image/tiff,image/avif,image/heic,.jps,.pdf,.ai,.eps,.psd';

export const IMAGE_ONLY_UPLOAD_FILE_TYPES =
    'image/png,image/jpeg,image/jpg,image/webp,image/gif,image/svg+xml,image/bmp,image/tiff,image/avif,image/heic';

export const IMAGE_PROPERTY_KEYS = [
    'Image 1',
    'Image 2',
    'Image upload 2',
    'Image 3',
    'Image upload 3',
    'Image 4',
    'Image 5',
    'Add reference image for the back',
    'Add reference image for the side prints',
    'Add reference image for the arm prints',
    'Upload a reference image for the leg backs',
    'Upload a reference image for the leg sides',
    'Please upload image you would like us to use.',
    'Please upload a screenshot of the head from our website you would like to edit.',
    'Attach another image if relevant',
    'Please upload a screenshot of the other head from our website you would like to edit.',
    'Attach another image if relevant 1',
    'Upload an image we can use as a reference',
    'Upload a second image (if appropriate)',
    'Upload a third image (if appropriate)',
    'Upload your image',
    'If own image chosen, please upload it here',
    'If own image chosen, please upload it here 1',
    'Upload University/College logo',
    'Upload University/College Logo',
    'Upload an image of the team kit (if you would like to give us a reference to work from):',
    'Upload an image of the team kit (if you would like to give us a reference to work from)',
    'Composite Preview',
    'Display Composite Preview',
    'Image upload of the team kit for reference (optional)',
    'Upload Your Own Image',
    'Upload Image of Graduate',
    'Image reference 1 for the head',
    'Image reference 2 for the head (if relevant)',
    'Image reference 3 for the head (if relevant)',
    'Image reference for other side of head',
    'Image reference 2 for other side of head (if relevant)',
    'Image reference 3 for other side of head (if relevant)',
];

export const IMAGE_PROPERTY_KEY_SET = new Set(IMAGE_PROPERTY_KEYS);
